// src/frontend/js/modern/shared/dom-helpers.js

// ---------- Utility methods ----------
export function extractProductId(element) {
	if (!element) return null;

	// 1) Check direct dataset/attribute on element
	let id = element.dataset.productId
		|| element.dataset.product_id
		|| element.dataset.rowId;
	if (!id) {
		id = element.getAttribute('data-product-id')
			|| element.getAttribute('data-product_id')
			|| element.getAttribute('data-row-id');
	}

	// 2) Check closest parent with any relevant ID attribute
	if (!id) {
		const parent = element.closest(
			'[data-product-id], [data-product_id], [data-row-id]'
		);
		if (parent) {
			id = parent.dataset.productId
				|| parent.dataset.product_id
				|| parent.dataset.rowId;
		}
	}

	// 3) Fallback: WooCommerce add-to-cart form
	if (!id) {
		const form = element.closest('form.cart, form.vtajaxform');
		if (form) {
			const input = form.querySelector(
				'input[name="add-to-cart"], input[name="product_id"]'
			);
			if (input) id = input.value;
		}
	}
	return id ? parseInt(id, 10) : null;
}

export function extractParentProductId(element) {
	let id = element.dataset.parentProductId || element.dataset.parent_product_id;
	if (!id) id = element.getAttribute('data-parent-product-id') || element.getAttribute('data-parent_product_id');
	if (!id) {
		const parent = element.closest('[data-parent-product-id], [data-parent_product_id]');
		if (parent) id = parent.dataset.parentProductId || parent.dataset.parent_product_id;
	}
	return id ? parseInt(id, 10) : null;
}

export function findProductForm(element, parentProductId) {
	let form = null;
	if (parentProductId) {
		const selectors = [
			`form.cart[method="post"][data-product_id="${parentProductId}"]`,
			`form.vtajaxform[method="post"][data-product_id="${parentProductId}"]`
		];
		for (const s of selectors) {
			const f = document.querySelector(s);
			if (f) { form = f; break; }
		}
	}
	if (!form) {
		const f = element.closest('form.cart[method="post"], form.vtajaxform[method="post"]');
		if (f) form = f;
	}
	if (!form && parentProductId) {
		const button = document.querySelector(
			`form.cart[method="post"] button[name="add-to-cart"][value="${parentProductId}"], ` +
			`form.vtajaxform[method="post"] button[name="add-to-cart"][value="${parentProductId}"], ` +
			`form.cart[method="post"] input[name="add-to-cart"][value="${parentProductId}"]`
		);
		if (button) form = button.closest('form');
	}
	return form;
}

export function buildFormData(element, productId, parentProductId) {
	const productType = element.dataset.productType || 'simple';
	let quantity = parseInt(element.dataset.quantity || 1, 10);
	const form = findProductForm(element, parentProductId);
	let formData = new FormData();
	if (form) {
		formData = new FormData(form);
		formData.delete('add-to-cart');
		if (formData.has('quantity')) {
			const qty = formData.get('quantity');
			if (qty) quantity = parseInt(qty, 10);
		}
	} else {
		const addToCartLink = element.closest('.product.post-' + parentProductId)?.querySelector('.add_to_cart_button');
		if (addToCartLink) {
			const qty = addToCartLink.dataset.quantity;
			if (qty) quantity = parseInt(qty, 10);
		}
	}
	const nonce = element.dataset.nonce || element.getAttribute('data-nonce');
	if (nonce && !formData.has('nonce')) formData.append('nonce', nonce);
	if (!formData.has('context')) formData.append('context', 'frontend');
	if (!formData.has('quantity')) formData.append('quantity', String(quantity));
	return { formData, quantity, productType, hasForm: !!form };
}

export function getWishlistIdFromElement(element) {
	let wid = element.dataset.wishlistId || element.dataset.wishlist_id;
	if (!wid) wid = element.getAttribute('data-wishlist-id') || element.getAttribute('data-wishlist_id');
	if (!wid) {
		const table = element.closest('.wlfmc-wishlist-table, .wlfmc-wishlist-items-wrapper');
		if (table) wid = table.dataset.id || table.getAttribute('data-id');
	}
	return wid ? parseInt(wid, 10) : 0;
}

export function getItemIdFromElement(element) {
	let id = element.dataset.itemId || element.dataset.item_id;
	if (!id) id = element.getAttribute('data-item-id') || element.getAttribute('data-item_id');
	if (!id) {
		const row = element.closest('[data-item-id], [data-item_id]');
		if (row) id = row.dataset.itemId || row.dataset.item_id || row.getAttribute('data-item-id');
	}
	return id ? parseInt(id, 10) : 0;
}
